module.exports = "../dist/img/img_1-27.f2c4.jpg";